import ProviderMetricsPage from './VCCProviderMetricsPage';

export default ProviderMetricsPage;